import { render, staticRenderFns } from "./ViewNotify.vue?vue&type=template&id=415c5b92"
import script from "./ViewNotify.vue?vue&type=script&lang=js"
export * from "./ViewNotify.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports